<!--
하우스 통관정보 수정
------------------------------------
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">
            <div class="uk-modal-header">
                <h4>
                    <i class="material-icons">edit</i>
                    통관정보 수정
                </h4>
            </div>

            <div class="uk-modal-body uk-padding-small">

                <!-- 하우스정보 -->
                <!-- [TASK-171 결정 14] 머리줄 = 제목 옆 괄호 상태 (예 「(오류)」) 인라인 텍스트. 재검사 버튼은 모달 하단 좌측 (footer) — 저장된 값으로 검사, 입력 중인 값은 저장 후 검사 -->
                <div class="uk-flex uk-flex-middle uk-flex-wrap customs-head">
                    <i class="material-icons">receipt</i>
                    <b>통관정보</b>

                    <!-- 검사 결과 (저장된 정보 기준): 모달을 열자마자 현재 결과가 보인다. 색 규칙 = 상세 > 배송정보 탭 (customs.blade.php) 과 동일 (정상 기본색 · 검사안함 회색 글자 `uk-text-muted`, 박스 없음 · 그 외 빨강) -->
                    <span
                        v-if="validationText"
                        class="customs-result-text badge-customs-validation"
                    >(<span v-if="validationValue === 99" class="uk-text-muted">{{ validationText }}</span><span v-else-if="validationValue === 1">{{ validationText }}</span><span v-else class="uk-text-danger font-bold">{{ validationText }}</span>)</span>
                </div>
                <table class="info-table small uk-width-1-1 border-highlight">
                    <colgroup>
                        <col style="width: 9rem">
                        <col>
                        <col style="width: 9rem">
                        <col>
                    </colgroup>

                    <tr>
                        <th>
                            수취인
                        </th>
                        <td>
                            <app-input-text
                                placeholder=""
                                v-model.trim="inputs.name"
                            ></app-input-text>
                        </td>
                        <th>
                            핸드폰
                        </th>
                        <td>
                            <app-input-text
                                placeholder=""
                                v-model.trim="inputs.cell"
                            ></app-input-text>
                        </td>
                    </tr>

                    <tr>
                        <th>

                            개인통관고유부호
                        </th>
                        <td>
                            <div class="uk-flex uk-flex-middle">
                                <app-input-text
                                    class="w-12rem"
                                    placeholder="P포함 13자리"
                                    v-model.trim="inputs.customs_clearance_no"
                                ></app-input-text>

                                <!-- 통관부호검사 버튼 -->
                                <!-- [TASK-171] 명칭 「검사」→「조회」 (상세 > 배송정보 탭 [조회] 와 통일 — 새 「재검사」 버튼과 혼동 방지. 입력 중인 값으로 새 창에서 외부 조회) -->
                                <a
                                    class="ml-1rem uk-button uk-button-small uk-button-primary btn-customs-lookup"
                                    target="_blank"
                                    title="개인통관고유부호 조회 (입력 중인 값으로 새 창에서 조회합니다)"

                                    :href="validationUrl"
                                >
                                    <i class="material-icons" style="color: #fff">search</i>
                                    조회
                                </a>

                            </div>

                        </td>
                        <td colspan="2" >
                            <!-- [TASK-153 R9/R10] 통관정보 검사안함 설정 — 상세 > 배송정보 (customs.blade.php) 와 동일 마크업·클래스 -->
                            <!-- [TASK-155] 설정 / 설정해지 버튼 = 아이콘 없이 텍스트만 -->
                            <div v-if="canIgnore">
                                <div class="uk-flex uk-flex-middle uk-flex-right uk-flex-wrap">
                                    <!-- 미설정: 빨강 설정 버튼 -->
                                    <button
                                        v-if="house.customs_validation !== 99"
                                        type="button"
                                        class="uk-button uk-button-small btn-ignore-customs"
                                        @click="$refs['ignore-customs-validation'].form()"
                                    >
                                        통관부호 검사안함 설정
                                    </button>

                                    <!-- 설정중: 빨강 라벨 + 해지 버튼 -->
                                    <template v-else>
                                        <span class="uk-label uk-label-danger font-size-1rem badge-ignore-on">통관정보 검사안함 설정중..</span>
                                        <button
                                            type="button"
                                            class="uk-button uk-button-small uk-button-white ml-0d5rem btn-unignore-customs"
                                            @click="$refs['unignore-customs-validation'].form()"
                                        >
                                            통관부호 검사안함 설정해지
                                        </button>
                                    </template>
                                </div>

                                <div class="note-ignore-customs">
                                    <p>O로 시작하는 일회용 통관부호로 통관시 [통관부호 검사안함 설정] 해 주시기 바랍니다.</p>
                                </div>

                                <div v-if="house.customs_validation === 99" class="uk-text-right uk-text-muted">
                                    사유 : {{ house.ignore_customs_validation_reason }}
                                </div>

                                <ignore-customs-validation :csrf-token="csrfToken" :house="house" ref="ignore-customs-validation" @done="refreshPage">
                                </ignore-customs-validation>
                                <unignore-customs-validation :csrf-token="csrfToken" :house="house" ref="unignore-customs-validation" @done="refreshPage">
                                </unignore-customs-validation>
                            </div>

                        </td>
                    </tr>

                    <tr>
                        <th>
                            영문 이름
                        </th>
                        <td>
                            <app-input-text
                                placeholder=""
                                v-model.trim="inputs.customs_first_name"
                            ></app-input-text>
                        </td>
                        <th>
                            영문 성
                        </th>
                        <td>
                            <app-input-text
                                placeholder=""
                                v-model.trim="inputs.customs_last_name"
                            ></app-input-text>
                        </td>
                    </tr>



                </table>

                <!-- 주의사항 -->
                <div class="warnings mt-0d5rem">
                    * 기타통관정보(사업자 등)는
                    <a class="font-bold uk-link-reset" :href="'/prods/' + firstHouseProd.id + '/house-info'" title="배송정보 탭으로 이동하기">[상세페이지 > 배송정보 탭]</a>
                    에서 수정가능합니다.

                </div>

                <!-- 하우스정보 -->
                <div class="mt-1rem">
                    <i class="material-icons">mail</i>
                    <b>배송정보</b>
                </div>
                <table class="info-table small uk-width-1-1">
                    <colgroup>
                        <col style="width: 9rem">
                        <col>
                        <col style="width: 9rem">
                        <col>
                    </colgroup>

                    <tr>
                        <th>
                            배송코드
                        </th>
                        <td>
                            {{ house.code }}
                        </td>
                        <th>

                            합배송코드
                        </th>
                        <td>
                            {{ house.sp_code }}
                        </td>
                    </tr>



                    <tr>

                        <th class="border-highlight">
                            우편번호
                        </th>
                        <td class="border-highlight">
                            <div class="uk-flex uk-flex-left">
                                <app-input-text
                                    class="uk-width-expand"
                                    placeholder="5자리 우편번호"
                                    v-model.trim="inputs.zipcode"
                                ></app-input-text>
                                <app-zipcode-search
                                    class="uk-button-small w-10rem"
                                    @found="foundZipcode"
                                ></app-zipcode-search>
                            </div>

                        </td>

                        <th>
                            운송장
                        </th>
                        <td>
                            {{ house.blno }}
                            <div class="uk-text-meta" v-if="house.sub_blnos">
                                {{ house.sub_blnos }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th>
                            주소
                        </th>
                        <td colspan="3">
                            <app-input-text
                                    placeholder=""
                                    v-model.trim="inputs.addr1"
                            ></app-input-text>
                            <app-input-text
                                placeholder=""
                                v-model.trim="inputs.addr2"
                                ref="addr2"
                            ></app-input-text>
                        </td>
                    </tr>


                </table>

                <!-- 상품정보 -->
                <div class="uk-margin-small-top">
                    <i class="material-icons">list</i>
                    <b>상품정보({{ houseProds.length }})</b>
                </div>
                <div class="prod-list">
                    <table class="info-table small uk-width-1-1">
                        <colgroup>
                            <col style="width: 7rem">
                            <col style="width: 8rem">
                            <col style="width: 4rem">
                            <col style="width: 5rem">
                            <col>

                        </colgroup>

                        <thead>
                        <tr>
                            <th scope="col" class="uk-text-center">
                                상품번호
                            </th>
                            <th scope="col" class="uk-text-center">
                                배송단계
                            </th>

                            <th scope="col" class="uk-text-center">
                                수량
                            </th>
                            <th scope="col" class="uk-text-center">
                                이미지
                            </th>
                            <th scope="col" class="uk-text-left">
                                상품정보
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="(prod) in houseProds"
                            :key="prod.id"
                        >
                            <td scope="col" class="uk-text-center">
                                {{ prod.id }}
                                <a class="detail-link" :href="'/prods/' + prod.id" target="_blank"
                                   title="상세페이지 새창으로 열기">
                                    <i class="material-icons">open_in_new</i>
                                </a>
                            </td>
                            <td scope="col" class="uk-text-center">
                                <div class="" title="배송단계">
                                    {{ prod.state_text }}
                                </div>
                            </td>

                            <td scope="col" class="uk-text-center">
                                {{ prod.amount }}
                            </td>
                            <td scope="col" class="uk-text-center">
                                <img class="prod-img" :src="prod.img_url"/>
                            </td>

                            <td scope="col" class="uk-text-left">
                                <div class="uk-flex uk-flex-wrap">
                                    <div class="uk-margin-small-right" title="쇼핑몰" v-if="prod.vender_mall"><i
                                        class="material-icons md-18">info</i>{{ prod.vender_mall }}
                                    </div>
                                    <div class="uk-margin-small-right" title="브랜드" v-if="prod.brand"><i
                                        class="material-icons md-18">info</i>{{ prod.brand }}
                                    </div>
                                    <div class="uk-width-1-1" title="상품명" v-if="prod.name"><i
                                        class="material-icons md-18">title</i>{{ prod.name }}
                                    </div>

                                    <div class="uk-margin-small-right" title="색상" v-if="prod.color"><i
                                        class="material-icons md-18">info</i>{{ prod.color }}
                                    </div>
                                    <div class="uk-margin-small-right" title="사이즈" v-if="prod.size"><i
                                        class="material-icons md-18">info</i>{{ prod.size }}
                                    </div>
                                </div>

                            </td>
                        </tr>
                        </tbody>

                    </table>
                </div>



            </div>

            <!-- [TASK-171] footer 좌/우 분리 (버튼들은 한 줄, 글자 줄바꿈 없음).
                 좌측 = 재검사 버튼 + 그 아래 입력 변경 안내 / 우측 = [취소] [통관정보 저장] + 그 아래 저장 보조 문구 (우측 정렬 둘째 줄) -->
            <div class="uk-modal-footer uk-flex uk-flex-between uk-flex-top uk-flex-wrap">

                <div class="uk-text-left footer-left">
                    <!-- 재검사 버튼: 미확인·오류에만 노출 (상세 탭과 동일). 회색 버튼 (상세 탭 검사 버튼과 같은 uk-button-gray, 크기만 footer 기본) + refresh 아이콘 (결정 15 — TASK-155 아이콘 없음 관행의 예외). 입력값이 바뀌면 비활성. 누르면 검사 뒤 페이지 새로고침 -->
                    <customs-validation
                        v-if="canRecheck"
                        class="btn-customs-recheck"
                        label="통관정보 유효성 검사(현재정보로 재검사)"
                        title="저장된 통관정보로 검사합니다. 입력 중인 값은 반영되지 않습니다."
                        button-class="uk-button-gray uk-text-nowrap"
                        :csrf-token="csrfToken"
                        :house-id="house.id"
                        :show-icon="true"
                        :disabled="dirty"
                    ></customs-validation>

                    <div v-if="canRecheck && dirty" class="recheck-hint">입력한 값은 저장 후 검사됩니다</div>
                </div>

                <div class="uk-text-right footer-right">
                    <!--- 버튼 -->
                    <div class="uk-text-nowrap">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-modal-close"
                        >
                            <span uk-icon="icon: close"></span> 취소
                        </button>


                        <button
                            type="button"
                            class="uk-button uk-button-primary"
                            @click="submit"
                        >
                            <span uk-icon="icon: check"></span>
                            통관정보 저장
                        </button>
                    </div>

                    <div class="footer-note-save">통관정보를 바꿔 저장하면 자동으로 다시 검사됩니다</div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import regionAble from "../common/region-able.vue";

// [TASK-171] 통관정보 검사 결과 표시명 — App\Code\House\CustomsValidation 미러 (0 미확인 · 1 정상 · 9 오류 · 99 검사안함)
const CUSTOMS_VALIDATION_TEXT = {
    0: '미확인',
    1: '정상',
    9: '오류',
    99: '검사안함',
};

// [TASK-171] 입력값 변경(dirty) 판정 대상 — inputs 8 필드 전부 (주소 포함: "입력을 바꾸면 저장 후 검사" 한 줄 규칙)
const DIRTY_FIELDS = [
    'name',
    'cell',
    'customs_clearance_no',
    'customs_first_name',
    'customs_last_name',
    'zipcode',
    'addr1',
    'addr2',
];

/**
 * [TASK-171] dirty 비교용 정규화 — null / undefined / '' 를 같게, 앞뒤 공백 제거 (입력은 v-model.trim)
 * @param value
 * @returns {string}
 */
function normalizeInput(value) {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value).trim();
}

export default {
    mixins: [
        regionAble,
    ],
    components: {
        'ignore-customs-validation': require('./ignore-customs-validation.vue').default,
        'unignore-customs-validation': require('./unignore-customs-validation.vue').default,
        // [TASK-171] 재검사 버튼 (상세 탭 검사 컴포넌트 재사용 — 검사 완료 뒤 페이지 새로고침, 복귀 결정 #11)
        'customs-validation': require('./customs-validation.vue').default,
    },
    props: {
        // csrf-token
        csrfToken: String,

        // 정상처리 후 페이지새로고침 실행여부
        offRefreshWhenDone: {
            type: Boolean,
            default: false,
        },

        /**
         * [TASK-153] 통관정보 검사안함 설정 진입 가능 여부 (총괄 또는 회원사 본인)
         */
        canIgnore: {
            type: Boolean,
            default: false
        },
    },
    data: function () {
        return {

            // (object) 하우스정보
            house: {},

            // (array) 하우스 상품배열
            houseProds: [],

            // (array) 이동할 센터 options
            toRegionIdOptions: [],

            /**
             * 입력값
             */
            inputs: {

            },
        };
    },
    mounted: function () {
        //console.log('mounted in component');
    },
    computed: {
        /**
         * 첫번째 상품
         * @returns object
         */
        firstHouseProd() {
            if (this.houseProds.length === 0) {
                return {};
            }
            return this.houseProds[0];
        },

        /**
         * [TASK-171] 저장된 통관정보 검사 결과 코드 (house.customs_validation) — 미로딩이면 null
         * @returns {number|null}
         */
        validationValue() {
            const value = this.house.customs_validation;
            if (value === null || value === undefined || value === '') {
                return null;
            }
            return Number(value);
        },

        /**
         * [TASK-171] 검사 결과 표시명 (미로딩이면 '')
         * @returns {string}
         */
        validationText() {
            if (this.validationValue === null) {
                return '';
            }
            return CUSTOMS_VALIDATION_TEXT[this.validationValue] || '';
        },

        /**
         * [TASK-171] 재검사 버튼 노출 여부 — 상세 > 배송정보 탭과 동일 (미확인·오류에만. 정상·검사안함은 칩만)
         * @returns {boolean}
         */
        canRecheck() {
            return this.validationValue === 0 || this.validationValue === 9;
        },

        /**
         * [TASK-171] 입력값이 저장된 값(house)과 다른지 — 다르면 재검사 비활성 (재검사는 저장된 값으로만 검사)
         * @returns {boolean}
         */
        dirty() {
            return DIRTY_FIELDS.some((field) => {
                return normalizeInput(this.inputs[field]) !== normalizeInput(this.house[field]);
            });
        },

        /**
         * 개인통관고유부호 검증 url
         * @returns {string}
         */
        validationUrl() {
            let url = '/check-clearance-no?name=' + encodeURI(this.inputs.name)
                + '&clearance_no=' + encodeURI(this.inputs.customs_clearance_no)
                + '&cell=' + encodeURI(this.inputs.cell)
                + '&zipcode=' + encodeURI(this.house.zipcode);

            if (this.inputs.customs_first_name) {
                url += '&first_name=' + encodeURI(this.inputs.customs_first_name);
            }
            if (this.inputs.customs_last_name) {
                url += '&last_name=' + encodeURI(this.inputs.customs_last_name);
            }

            return url;
        }
    },
    methods: {
        /**
         * 우편번호 검색 이벤트 리스너
         */
        foundZipcode(value) {
            this.inputs.zipcode = value.zipcode;
            this.inputs.addr1 = value.addr;

            // 상세주소 포커싱
            this.$refs.addr2.inputFocus();
        },


        /**
         * 입력폼 display
         */
        displayForm() {

            UIkit.modal(this.$el).show();
        },

        /**
         * 폼
         * @param house_id 하우스ID
         */
        form(house_id) {

            // 초기화
            this.inputs = {
                name: null,
                cell: null,
                customs_clearance_no: null,
                customs_first_name: null,
                customs_last_name: null,
                zipcode: null,
                addr1: null,
                addr2: null,
            };

            // promise 생성
            let load = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/houses/' + house_id + '?with_owner_usable_agents',
                    contentType: 'application/json',
                    data: {},
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            });


            // promise 처리
            load.then((response) => {
                this.house = response.house;
                this.houseProds = response.house_prods;

                // 입력값 설정
                this.inputs.name = this.house.name;
                this.inputs.cell = this.house.cell;
                this.inputs.customs_clearance_no = this.house.customs_clearance_no;
                this.inputs.customs_first_name = this.house.customs_first_name;
                this.inputs.customs_last_name = this.house.customs_last_name;
                this.inputs.zipcode = this.house.zipcode;
                this.inputs.addr1 = this.house.addr1;
                this.inputs.addr2 = this.house.addr2;

                //console.log(response);
                // 폼띄우기
                this.displayForm();
            });
        },

        /**
         * 서브밋 전 검증
         * @return Promise
         */
        submitValidation() {
            return new Promise((resolve, reject) => {
                // 입력값 검증
                if (! this.inputs.name) {
                    reject('수취인명은 필수입니다.');
                    return;
                }
                if (! this.inputs.cell) {
                    reject('핸드폰은 필수입니다.');
                    return;
                }
                if (! this.inputs.customs_clearance_no) {
                    reject('개인통관고유부호는 필수입니다.');
                    return;
                }
                if (! this.inputs.zipcode) {
                    reject('우편번호는 필수입니다.');
                    return;
                }
                if (! this.inputs.addr1) {
                    reject('주소는 필수입니다.');
                    return;
                }
                // addr2 (주소 2행) 는 선택 항목 — 기존 데이터 중 addr2 공백 건이 다수이며
                // 사용자가 수정 없이 저장할 때도 막히지 않아야 함 (BUG-028 추가 이슈 C)

                resolve();
            });


        },

        /**
         * submit
         */
        submit() {
            // 입력값 검증처리
            this.submitValidation().then(() => {
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/regions/' + this.house.region_id + '/agents/' + this.house.agent_id + '/users/' + this.house.user_id + '/houses/' + this.house.id,
                        data: _.merge({
                            '_token': this.csrfToken,
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            }).then((response) => {
                UIkit.modal.alert(response.msg).then(() => {
                    // 페이지 새로고침
                    if (! this.offRefreshWhenDone) {
                        $.app.refresh();
                    }

                    // 완료이벤트
                    this.$emit('done');

                });
            }).catch((msg) => {
                alert(msg);
            });



        },
    },
}
</script>

<style lang="scss" scoped>
.warnings {
    color: #000;
}

// [TASK-171] 통관정보 머리줄 (아이콘 + 제목 + 괄호 검사 결과)
.customs-head {
    .material-icons {
        margin-right: 0.25rem;
    }
}

// [TASK-171 결정 14] 검사 결과 = 제목 줄 안 인라인 텍스트 「(오류)」 (박스·바·라벨 없음, 색은 안쪽 span 클래스)
.customs-result-text {
    margin-left: 0.25rem;
    font-size: 1rem;
}

// [TASK-171] 입력값 변경 시 재검사 비활성 안내 (footer 좌측, 버튼 바로 아래 한 줄 — 좌측 바 강조)
.recheck-hint {
    margin-top: 0.25rem;
    white-space: nowrap;
    padding-left: 0.5rem;
    border-left: 4px solid #e08a00;
    font-size: 1rem;
}

// [TASK-171] 저장 보조 문구 (footer 우측, [취소] [통관정보 저장] 아래 우측 정렬 둘째 줄 — 한 줄 유지)
.footer-note-save {
    font-size: 1rem;
    margin-top: 0.25rem;
    white-space: nowrap;
}

// 테이블
.info-table {
    th {
        background-color: #fafafa;
    }

    th, td {
        font-size: 0.875rem !important;
    }

    .material-icons {
        color: #666;
        margin-right: 0.25rem;
    }

    img.prod-img {
        width: 3rem;
        max-height: 3rem;
        margin-right: 0.5rem;
    }

    // 상품상세 링크
    a.detail-link {
        .material-icons {
            color: #1e87f0;
            margin: 0;
        }
    }

    // 테두리하이라이트
    &.border-highlight,
    th.border-highlight,
    td.border-highlight {
        border: 2px solid #1e87f0 !important;
    }

    th.border-highlight {
        border-right: none !important;
    }
    td.border-highlight {
        border-left: none !important;
    }
}

// 상품영역
.prod-list {
    overflow: auto;
    max-height: 12rem;
}


</style>
